















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { embedded } from '@/utils/react-native-webview'

@Component<WebViewHeader>({})
export default class WebViewHeader extends Vue {
    @Prop({ type: String, required: false }) public title?: string
    @Prop({ type: Number, default: 0 }) public readonly statusBarHeight?: number

    private embedded: boolean = embedded

    public get style() {
        if (!embedded) {
            return null
        }

        return {
            paddingTop: `${this.statusBarHeight}px`
        }
    }
}
